//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return {
             patientid: this.$store.state.userInfo.id,
             addressTitle:[],
             orederId: this.$route.query.orederId,
//             serviceid: this.$route.query.serviceid,
        }
    },
    methods:{
        getcodes(items,type){
            this.$store.state.addressList=items;
          this.$router.push({path: '/myOrderDetailsYF',query:{id: this.orederId==null?this.$store.state.orderAddress:this.orederId, befrom: 'orderList', addressType: type, addressInfo: items, isDelivery: 1,addressId: items.id}});
          },
        addAddress(){
            this.$router.push({path: '/address',query: {orederId: this.orederId}});
        },
        getMyAddress(){
             let params = {
                    patientid: this.patientid
                };
            let _this=this;
            this.$doRequest("/api/patientaddressinfo/getListByKey", params, res=>{
                _this.addressTitle=res;
            })
        },
        editClick(item){
            this.$router.push({path: '/address',query:{id:item,orederId: this.orederId}});
        }

    },
    created(){
        document.title = '收货地址管理';
        this.orederId = this.$route.query.orederId;
    },
    mounted(){
        this.getMyAddress();
    }
}



// WEBPACK FOOTER //
// ./src/views/addressedit/index.vue